<template>
  <span
    v-tooltip.top="compact ? { value: fullLabel, showDelay: 300 } : null"
    class="kb-type"
    :class="[typeClass, sizeClasses]"
  >
    <i
      v-if="memberType === 'captain'"
      class="pi pi-star-fill !text-[10px]"
    />
    <Icon
      v-else-if="memberType === 'redshirt'"
      name="simple-icons:startrek"
      class="!text-[11px] !leading-none"
    />
    <i
      v-else-if="memberType === 'pending'"
      class="pi pi-clock !text-[10px]"
    />
    <i
      v-else-if="memberType === 'member'"
      class="pi pi-user !text-[10px]"
    />
    <span v-if="finalLabel">{{ finalLabel }}</span>
  </span>
</template>

<script setup lang="ts">
import { startCase } from 'lodash-es'

const props = defineProps<{
  memberType: string
  size?: 'sm' | 'md' | 'lg'
  isRedshirtLieutenant?: boolean
  compact?: boolean
}>()

const sizeClasses = computed(() => {
  // Compact enforces a smaller footprint regardless of size prop
  if (props.compact) return '!px-1.5'
  switch (props.size) {
    case 'lg': return '!h-7 !px-2.5 !text-[13px]'
    case 'md': return '!h-6 !px-2 !text-xs'
    case 'sm':
    default: return ''
  }
})

const typeClass = computed(() => {
  switch (props.memberType) {
    case 'captain': return 'kb-type-captain'
    case 'member': return 'kb-type-member'
    case 'redshirt': return 'kb-type-redshirt'
    case 'pending': return 'kb-type-pending'
    default: return ''
  }
})

const fullLabel = computed(() => {
  const type = props.memberType
  if (type === 'redshirt' && props.isRedshirtLieutenant) return 'Red Shirt Lt.'
  if (type === 'redshirt') return 'Red Shirt'
  return startCase(type || 'Unknown')
})

const finalLabel = computed(() => {
  if (!props.compact) return fullLabel.value
  // Compact: show 'Lt' only for redshirt lieutenant, otherwise icon-only
  return props.memberType === 'redshirt' && props.isRedshirtLieutenant ? 'Lt' : ''
})
</script>
